import { useTeacherGetAnswers } from 'approot/activity-builder/present/activity-answers.hooks';
import { useBatchAnswersContext } from '../../shared/batch-answers.context';
import FillInBlanksViewContent from '../fill-in-blanks-view-content';
import { ViewProps } from '../fill-in-blanks.constants';
import { useActivityBuilderFlags } from 'approot/activity-builder/activity-builder-flags';

const FillInBlanksViewRespond = (props: ViewProps) => {
  const { id } = props;

  const { activityBuilderRespondFlag } = useActivityBuilderFlags();
  const { componentAnswers, variables } = useTeacherGetAnswers({
    fetchPolicy: 'cache-only',
    componentId: id,
    skip: !activityBuilderRespondFlag,
  });

  const { handleUpdate } = useBatchAnswersContext();

  return (
    <FillInBlanksViewContent
      {...props}
      componentAnswers={componentAnswers}
      updateAnswer={input => {
        if (variables) {
          handleUpdate({
            input,
            variables,
          });
        }
      }}
    />
  );
};

export default FillInBlanksViewRespond;
